export const selectRegisterDomain = () => (state) => state.register;
